module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-with-bg"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.lable))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('bs-numbers', {
    attrs: {
      "count": _vm.count,
      "length": "8"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25870328!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragment/number-with-bg/index.vue
// module id = 228
// module chunks = 0